// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalculatorOutlinedSvg from "@fishx/icons-svg/es/asn/CalculatorOutlined";
import FishxIcon from '../components/FishxIcon';

var CalculatorOutlined = function CalculatorOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorOutlinedSvg
  }));
};

CalculatorOutlined.displayName = 'CalculatorOutlined';
export default React.forwardRef(CalculatorOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CalculatorOutlined.js
// module id = 2146
// module chunks = 0